import { CommercialSeries } from '@bytel/checkout';

import { OptionsOauth2 } from '../common/public-api';
import { PartnerOffers } from './partner.interface';

export interface Configuration {
    environment: string;
    localUrl: string;
    resourceUrl: string;
    xSource?: string;
    salesApiVersion?: string;
}

export interface OptionPicasso {
    emptycallBackUrl: string;
    loginUrl: string;
}

export interface ConfigIban {
    mask: {
        [key: string]: number;
    };
}

export interface ReinsuranceConfig {
    noOdr?: {
        commercialSeries?: string[];
        rangesNg?: string[];
    };
}

export interface GlobalConfig {
    mixedCartActive: boolean;
    expirationCartValue: number;
    shouldCheckFTTH: boolean;
    features: {
        openBankingEnabled: boolean;
    };
    widgets: {
        faiWidget: IWidgetConfig;
        faiElig: string;
    };
    origin: string;
    iban: ConfigIban;
    reinsurance?: ReinsuranceConfig;
    wall: {
        [key: string]: string;
    };
    yama: {
        referrers: string[];
    };
    partner: {
        offers: PartnerOffers;
    };
    chatbot?: {
        updatecasetlvUrl: string;
    };
    prisme: {
        url: string;
        js_error: string;
        status: string;
    };
    cms: {
        magento: string;
        battlefront: string;
        battlefront_i18n: string;
        bta: string;
    };
    oldPaymentPage: boolean;
    commercialSeriesFmsToPayToday: CommercialSeries[];
    graphQL: {
        url: string;
        scope: string;
        xsource: string;
    };
    crossSellActiveForFAMOnCheckout: boolean;
    specialOffers: {
        summerEdition: string;
    };
}

export interface IInitialConfig {
    oauth: OptionsOauth2;
    picasso: OptionPicasso;
    environment: ENV_LIST;
    version: 'stable' | 'canary';
    global: GlobalConfig;
    features: Record<string, boolean>;
}

export interface IWidgetConfig {
    src: string;
    redirect_rules: IWidgetRule[];
}

export interface IWidgetRule {
    offer_name: string;
    attached_rules: IWidgetRedirectRule[];
}

export interface IWidgetRedirectRule {
    isActive: boolean;
    property: string;
    value: number;
    operator: ComparisonOperator;
    redirect_url: string;
    focus?: string;
}

export enum ENV_LIST {
    LOCAL = 'LOCAL',
    TEST = 'TEST',
    PREPRODUCTION = 'PREPROD',
    PRODUCTION = 'PROD',
}

export enum ComparisonOperator {
    EQUAL = '===',
    NOT_EQUAL = '!==',
    GREATER_THAN = '>',
    LESS_THAN = '<',
    GREATER_THAN_OR_EQUAL = '>=',
    LESS_THAN_OR_EQUAL = '<=',
}
